/**
 * ProductSizeSelector Component
 */
(function () {

    'use strict';

    /**
     * Size Selector
     * @name productSizeSelector
     * @type ItxProductSizeSelectorCmpCtrl
     */
    var ItxProductSizeSelectorCmp = {
        bindings: {
            product: '<',
            list: '<',
            position: '<',
            closeDialog: '&',
            productController: '<'
        },
        controller: ItxProductSizeSelectorCmpCtrl,
        controllerAs: 'productSizeSelectorCtrl',
        templateUrl: 'product-size-selector.tpl'
    };

    ItxProductSizeSelectorCmpCtrl.$inject = [
        '$window', 
        'ItxShopCartFct', 
        'ItxHeaderFct'
    ];

    function ItxProductSizeSelectorCmpCtrl( 
        $window, 
        ItxShopCartFct, 
        ItxHeaderFct
    ) {
        
        var _this = this;

        _this.selectedSize = null;

        this.imList = _this.list ? _this.list : document.getElementsByClassName('latest-products').length > 0 ? 'vistos_recientemente' : 'productos_relacionados';        
        _this.productIndex = _this.position;

        _this.addToCart = function () {
            
            if (_this.selectedSize && ItxShopCartFct.canIAddItems()) {
                ItxShopCartFct.addToCart(
                    _this.product,
                    _this.product.activeDetail.colors[_this.product.state.selectedColorIndex],
                    _this.selectedSize)
                    .then(function () {
                        ItxHeaderFct.showMiniCart();
                        
                        // EVENT PARENT
                        if(_this.productController){
                            _this.productController.productAdded = true;
                        }
                        _this.closeDialog();
                        // $scope.$apply();
                    });
            }

        };

            /**
         * ngdoc method
         * @methodOf common.product.product-view-menu.component:itxProductViewMenu
         * @name goToShopCart
         * @description
         * Navigate to shop cart.
         */
        _this.goToShopCart = function () {
            $window.location.href = joyr.utils.getCommonPageUrl('ItxShopCartPage', false, false);
        };
    }

    /** Public */
    angular.module('itxApp.catalog')
        .component('itxProductSizeSelector', ItxProductSizeSelectorCmp);

})();
